import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';
import Application from './Application';
import Languages from './Languages';
import Ratings from './Ratings';

const Index = ({ data }) => {
  const { main, application, languages, ratings, footer } = data;
  return (
    <div className="Index">
      <Header data={main} />
      <Application data={application} />
      <Languages data={languages} />
      <Ratings data={ratings} />
      <Footer data={footer} />
    </div>
  );
};

Index.propTypes = {
  data: PropTypes.shape({
    main: PropTypes.shape({}),
    application: PropTypes.shape({}),
    languages: PropTypes.shape({}),
    ratings: PropTypes.shape({}),
    footer: PropTypes.shape({}),
  }).isRequired,
};

export default Index;
